import PropTypes from 'prop-types';
import { createRef, Component, useRef } from 'react';

import TrackableCheckboxFilter from './TrackableCheckboxFilter';
import { useAccessibleInteractivity } from '../../../../hooks';

const MAX_VISIBLE_OPTIONS = 5;

const ExpandLink = ({ onClick, toFocusForAccessibility }) => {
  const linkRef = useRef();
  useAccessibleInteractivity(linkRef, event => {
    onClick(event);
    toFocusForAccessibility && toFocusForAccessibility.current && toFocusForAccessibility.current.focus();
  });

  return (
    <li>
      <a ref={linkRef} onClick={onClick} className="expand" tabIndex="0">
        <i className="fa fa-plus-circle" aria-hidden="true" />
        Show All Filters
      </a>
    </li>
  );
};

class CheckboxFilter extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
    filters: PropTypes.arrayOf(PropTypes.object).isRequired,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.expandedFocusRef = createRef();
    this.state = {
      expanded: this.defaultExpanded(props.options, props.selected),
    };
  }

  onChange(slug, wasChecked) {
    const updatedValues = wasChecked ? this.props.selected.filter(v => v !== slug) : [...this.props.selected, slug];
    this.props.onChange(updatedValues);
  }

  isChecked(child) {
    return this.props.selected.includes(child.slug);
  }

  isHidden(a) {
    return !this.isChecked(a) && a.count === 0;
  }

  defaultExpanded(options, selected) {
    if (selected.length > 0) {
      if (selected.some(slug => options.findIndex(option => option.slug === slug) >= MAX_VISIBLE_OPTIONS)) {
        return true;
      }
    }

    return false;
  }

  isBelowFold(i) {
    return i >= MAX_VISIBLE_OPTIONS && !this.state.expanded;
  }

  render() {
    const availableOptions = this.props.options.filter(a => !this.isHidden(a));

    return (
      <ul className={`filterList checkboxFilter ${this.props.className}`}>
        {availableOptions.map((a, i) => (
          <TrackableCheckboxFilter
            track={{
              track: 'filter',
              'track-filter-name': this.props.title,
              'track-filter-option': a.name,
            }}
            slug={a.slug}
            checked={this.isChecked(a)}
            onChange={this.onChange}
            label={`${a.proper_name} (${a.count})`}
            focusRef={i == 5 ? this.expandedFocusRef : null}
            disabled={this.isBelowFold(i)}
            key={a.uid}
          />
        ))}
        {!this.state.expanded && availableOptions.length > MAX_VISIBLE_OPTIONS && (
          <ExpandLink
            onClick={() => this.setState({ expanded: true })}
            toFocusForAccessibility={this.expandedFocusRef}
          />
        )}
      </ul>
    );
  }
}

export default CheckboxFilter;
